module.exports = __webpack_public_path__ + "media/images/front/icon_04_arrow_gr-a5a03f9aac8564176ab352101beccaa5.png";